(function (Drupal, $) {
  Drupal.behaviors.tabedFormsBlocks = {
    attach: function attach(context) {
      $('.block.tabbed-forms', context).each(function () {
        var tabs = $('.js--tf-tab');
        // For easy reference
        var keys = {
          end: 35,
          home: 36,
          left: 37,
          up: 38,
          right: 39,
          down: 40,
          delete: 46
        };

        // Add or substract depending on key pressed
        var direction = {
          37: -1,
          38: -1,
          39: 1,
          40: 1
        };

        tabs.click(function(){
          if ($(this).hasClass('selected')){
            return;
          } else {
            selectTab($(this).data('tab'), false);
          }
        });

        tabs.on('keydown', keyDownListener);

        // Aria for autocomplete listbox
        var autoCompleteListID = $('ul.ui-autocomplete').attr('id');
        var autoCompletelist = $('#' + autoCompleteListID);
        var autoInput = $('input.form-autocomplete');

        autoInput.attr('aria-autocomplete', 'list');
        autoInput.attr('aria-controls', autoCompleteListID);
        autoInput.attr('aria-haspopup', 'listbox');
        autoInput.attr('aria-expanded', 'false');
        autoCompletelist.attr('aria-role', 'listbox');

        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutationRecord) {
              if(autoCompletelist.css('display') == 'none') {
                autoInput.attr('aria-expanded', 'false');
              } else {
                autoInput.attr('aria-expanded', 'true');
              }
          });    
        });
      
        var target = document.getElementById(autoCompleteListID);
        observer.observe(target, { attributes : true, attributeFilter : ['style'] });


        function keyDownListener(event){
          var key = event.keyCode;
          switch (key) {
            case keys.end:
              event.preventDefault();
              // Activate last tab
              selectTab(tabs, tabs.length);
              break;
            case keys.home:
              event.preventDefault();
              // Activate first tab
              selectTab(tabs, 0);
              break;
      
            // Up and down are in keydown
            // because we need to prevent page scroll >:)
            case keys.left:
            case keys.right:
              switchTabOnArrowPress(event);
              break;
          };

        }

        // Either focus the next, previous, first, or last tab
        // depening on key pressed
        function switchTabOnArrowPress (event) {
          var pressed = event.keyCode;
          var currentTab = $('.js--tf-tab.selected').first();
          var currentTabNum = parseInt(currentTab.data('tab'));

          if (direction[pressed]) {
            if (tabs[(currentTabNum - 1) + direction[pressed]]) {
              selectTab(currentTabNum + direction[pressed], true);
            }
            else if (pressed === keys.left) {
              selectTab(tabs.length, true);
            }
            else if (pressed === keys.right, true) {
              selectTab(1);
            };
          };
        };

        function selectTab(clickedTab, setFocus = false) {
          var pieces = $('.js--tf-content');
          tabs.removeClass('selected').attr('aria-selected', false).attr('tabindex', -1);
          pieces.removeClass('selected').attr('tabindex', -1);
          $('[data-tab="' + clickedTab + '"]').addClass('selected').attr('aria-selected', true).attr('tabindex', 0);
          $('[data-content="piece-' + clickedTab + '"]').addClass('selected').attr('tabindex', 0);
          if (setFocus){
            $('[data-tab="' + clickedTab + '"]').focus();
          }
        }
      });
    }
  }
})(Drupal, jQuery);
